/*
// jei reikia, galime perrasyti core komponentus, pvz.
init_tooltips = function(context) {
	$('[data-toggle="tooltip"]', context).tooltip({placement:'bottom'});
}
*/

(function( $ ) {
    $.fn.qtySelect = function() {

        return this.each(function() {
            var parent = $(this);
            var input = $('input', parent);
            var value = $('.value', parent);

            $('.plus', parent).off('click');
            $('.plus', parent).on('click', function(e){
                e.preventDefault();
                var qty = parseInt(input.val()) + 1;
                if (qty >= input.attr('max')) {
                    qty = input.attr('max');
                }
                input.val(qty);
                input.change();
                if(!parent.hasClass('with-input')) {
                    value.html(qty);
                }
                if (qty > 0) $('.minus', parent).removeClass('disabled');
                if (qty >= input.attr('max')) $('.plus', parent).addClass('disabled');
                if ($(this).hasClass('submit')) {
                    parent.closest('form').submit();
                }
            });

            $('.minus', parent).off('click');
            $('.minus', parent).on('click', function(e){
                e.preventDefault();
                var qty = parseInt(input.val()) - 1;
                if (qty < 0) qty = 0;
                input.val(qty);
                input.change();
                if(!parent.hasClass('with-input')) {
                    value.html(qty);
                }
                if (qty == 0) $('.minus', parent).addClass('disabled');
                if (qty < input.attr('max')) $('.plus', parent).removeClass('disabled');
                if ($(this).hasClass('submit')) {
                    parent.closest('form').submit();
                }
            });

        });
    };

}( jQuery ));

$(function () {
    update_breadcrumb();
    update_product_list_select();

    $(window).resize(function() {
        update_breadcrumb();
    });

    $('.qty-select').qtySelect();
    syncMegaMenuWidth();
    initMegaMenuGroups();
});

// Catalog mega menu: subcategory panels may grow up to the right edge of the viewport
function syncMegaMenuWidth() {
    $(document).on('mouseenter', '.navbar-mega-nav > .nav-item', function () {
        var list = $(this).children('.dropdown-menu');

        list[0].style.removeProperty('--mega-panel-max-width');
        if (window.innerWidth < 992) return;

        var panelLeft = this.getBoundingClientRect().left + list.outerWidth();
        list[0].style.setProperty('--mega-panel-max-width', (document.documentElement.clientWidth - 16 - panelLeft) + 'px');
    });
}

// Catalog mega menu (mobile): group links open as an accordion, one group at a time
function initMegaMenuGroups() {
    $('.navbar-mega-nav').on('click', '.mega-menu-group-toggle', function (e) {
        // keep Bootstrap from closing the category dropdown
        e.preventDefault();
        e.stopPropagation();

        var group = $(this).closest('.widget-links');
        var open = !group.hasClass('open');

        group.closest('.mega-menu-panel').find('.widget-links.open').not(group)
            .removeClass('open')
            .find('.mega-menu-group-toggle').attr('aria-expanded', 'false');

        group.toggleClass('open', open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
    });
}
